import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

export default {
  productFeature: {
    id: 'product_jp_product_feature',
    defaultMessage: 'Product feature',
  },
  chooseCapacity: {
    id: 'product_jp_about_battery_modal_updated_body_heading',
    defaultMessage: 'Choose your battery capacity',
  },
  description: {
    id: 'product_jp_about_battery_modal_updated_description',
    defaultMessage:
      'Electronic devices like smartphones and laptops can experience battery wear over time, especially with frequent charging or use while charging, which leads to a decrease in battery capacity. At Back Market, we offer three battery options to match your needs.',
  },
  batteryTier1Title: {
    id: 'product_jp_about_battery_modal_updated_tier1_title',
    defaultMessage: '80% ~ 89%',
  },
  batteryTier1Description: {
    id: 'product_jp_about_battery_modal_updated_tier1_description',
    defaultMessage:
      'Sufficient for everyday use. Recommended for price-conscious customers.',
  },
  batteryTier2Title: {
    id: 'product_jp_about_battery_modal_updated_tier2_title',
    defaultMessage: '90% ~ 99%',
  },
  batteryTier2Description: {
    id: 'product_jp_about_battery_modal_updated_tier2_description',
    defaultMessage:
      'Best value! Perfect for customers who want a balance of price and performance.',
  },
  batteryTier3Title: {
    id: 'product_jp_about_battery_modal_updated_tier3_title',
    defaultMessage: '100% (New)',
  },
  batteryTier3Description: {
    id: 'product_jp_about_battery_modal_updated_tier3_description',
    defaultMessage:
      'Brand-new battery capacity. Recommended for those who want to use their device without worrying about charging.',
  },
} as Record<string, I18nDefinition>
